export default {
  image: 'Kapsel_1_2.png',
  pdf: '220829_WA-MIWO_019_Kapsel1_2_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-MIWO-019',
    technicalValues: {
      soundReductionIndex: {
        output: '54,0',
        value: 54
      },
      heatTransferCoefficient: {
        output: '0,16',
        value: 0.16
      },
      fireBehavior: {
        output: 'schwerentflammbar (B1)',
        value: 'B1'
      },
      fireResistanceOuter: {
        output: 'F 60-B / K\u208260' ,
        value: 'F-60-B-K260'
      },
      fireResistanceInner: {
        output: 'F 60-B / K\u208260' ,
        value: 'F-60-B-K260'
      }
    },
    name: 'Wandaufbau mit Mineralwolle l Aufbau 19',
    construction: {
      composition: [
        {
          output: 'organischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'org-1'
        },
        {
          output: '60 mm Sto-Speedlamelle Typ ll',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'msp-60'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-12'
        },
        {
          output: '60/180',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-180'
        },
        {
          output: '180 mm Steinwolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cirw-180'
        },
        {
          output: '15 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ig-15'
        },
        {
          output: '18 mm Gipsfaserplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'iq-18'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '293',
        value: 293
      }
    }
  }
}
